<template>
  <span>{{costText}}</span>
</template>

<script>
  export default {
    name: 'job-cost',
    props: ['cost'],
    computed: {
      costText() {
        if (!this.cost) {
          return '';
        }
        const cost = parseFloat(this.cost);
        if (isNaN(cost) || cost <= 0) {
          return '';
        }
        const currency = window.orgCurrencyEntity ? window.orgCurrencyEntity : '$';

        return currency + cost.toFixed(2);
      }
    }
  }
</script>